// extracted by mini-css-extract-plugin
export var editInput = "_ig-0";
export var editInputCompact = "_ig-2";
export var editInputLarge = "_ig-1";
export var editInputSmall = "_ig-3";